import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import LandingPage from './components/LandingPage';
import Nauczanie from './components/Nauczanie';
import Zdjecia from './components/Zdjecia';
import Koncerty from './components/Koncerty';
import Zyciorys from './components/Zyciorys';
import Nagrania from './components/Nagrania';
import Kontakt from './components/Kontakt';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/nauczanie" element={<Nauczanie />} />
          <Route path="/zdjecia" element={<Zdjecia />} />
          <Route path="/koncerty" element={<Koncerty />} />
          <Route path="/zyciorys" element={<Zyciorys />} />
          <Route path="/nagrania" element={<Nagrania />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;